import React, { useEffect, useState } from "react"
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css' // This only needs to be imported once in your app
import MasonryWall from "components/shared/MasonryWall"
import GalleryGridItem from "./GalleryGridItem"
import Button from "components/shared/Button"

const GalleryGrid = (props) => {
	const [paginationLimit, setPaginationLimit] = useState(12)
	const [postsHtml, setPostsHtml] = useState("")
	const [lightboxImages, setLightboxImages] = useState([])
	const [photoIndex, setPhotoIndex] = useState(0)
	const [isOpen, setIsOpen] = useState(false)

	const postsPerPage = 12
	let sizes = {}

	if (props.columns !== 4) {
		sizes = {
			default: 2
		}
	} else {
		sizes = {
			default: 4,
			992: 3,
			768: 2
		}
	}

	useEffect(() => {
		setImages(props.images)
	}, [props.images])

	const viewMoreImages = () => {
		setPaginationLimit(paginationLimit + postsPerPage)
		setImages()
	}

	const openOnKeyDown = (e, index) => {
		if (e.keyCode === 13) {
			setPhotoIndex(index)
			setIsOpen(true)
		}
	}

  const setImages = (images = null) => {
		let postCount = 0
		let postsHtml
		let currentImages = images
		let lightboxImages = []

		if (currentImages === null) currentImages = images

		if (currentImages.length > 0) {
			postsHtml = currentImages.map((image, i) => {
				if (postCount < paginationLimit) {
					postCount++
					if (image) {
						lightboxImages.push(image.localFile.publicURL)
						return (
							<div
								role="button" 
								aria-pressed="false"
								key={i}
								tabIndex={i}
								onClick={() => {
									setPhotoIndex(i)
									setIsOpen(true)
								}}
								onKeyDown={(e) => openOnKeyDown(e, i)}
							>
								<GalleryGridItem
									key={i}
									// size={this.calcSize(image.localFile.resize.gatsbyImageData.height)}
									thumbnail={image.localFile.resize.gatsbyImageData}
									largeImage={image.localFile.publicURL}
									altText={image.altText}
									borderOnHover={props.borderOnHover}
								/>
							</div>
						)
					} else {
						return null
					}
				} else {
					return null
				}
			})

			setPostsHtml(postsHtml)
			setLightboxImages(lightboxImages)
		}
	}

	return (
		<>
			<MasonryWall breakpoints={sizes}>
				{postsHtml}
			</MasonryWall>
			{paginationLimit < props.images.length &&
				<div className="pt-3">
					<Button as="button" onClick={viewMoreImages} color="black">
						<span>View more images</span>
					</Button>
				</div>
			}
			{isOpen && (
				<Lightbox
					mainSrc={lightboxImages[photoIndex]}
					nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
					prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
					onCloseRequest={() => setIsOpen(false)}
					onMovePrevRequest={() =>
						setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
					}
					onMoveNextRequest={() =>
						setPhotoIndex((photoIndex + 1) % lightboxImages.length)
					}
				/>
			)}
		</>
	)
}

GalleryGrid.defaultProps = {
	columns: 4,
	borderOnHover: false
}

export default GalleryGrid